import { ActivityType } from '../../entities';

export class ActivityTypeMapping {
  public static getActivityTypeFor<TExternalOrOtherWorkoutType>(
    otherWorkoutType: TExternalOrOtherWorkoutType,
    mapping: Map<ActivityType, TExternalOrOtherWorkoutType[]>,
  ): ActivityType | undefined {
    for (const [activityType, mappings] of mapping.entries()) {
      if (mappings.includes(otherWorkoutType)) {
        return activityType;
      }
    }
    // undefined means not applicable, and can be ignored
    return undefined;
  }

  // Runtime check to ensure all activity types are considered in the mapping
  public static validateThatAllActivityTypesAreMapped<TExternalOrOtherWorkoutType>(
    activityTypeMap: Map<ActivityType, TExternalOrOtherWorkoutType[]>,
  ): void {
    const allActivityTypes = Object.values(ActivityType);
    const missingActivityTypes = allActivityTypes.filter((activityType) => !activityTypeMap.has(activityType));

    if (missingActivityTypes.length > 0) {
      throw new Error(`Critical: All ActivityTypes should be mapped. Missing: ${missingActivityTypes.join(', ')}`);
    }
  }
}
